export default "/assets/images/filter-air3.c54de9c961805724.webp";